@file:OptIn(ExperimentalSerializationApi::class)

package com.gsb.vyapar.bhagya.domain

import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import korlibs.io.compression.compress
import korlibs.io.compression.deflate.GZIP
import korlibs.io.compression.uncompress
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromByteArray
import kotlinx.serialization.encodeToByteArray
import kotlinx.serialization.protobuf.ProtoBuf

@Serializable
data class Location(
    val address: String? = null,
    val city: String? = null,
    val district: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val state: String? = null,
    val pincode: String? = null
) {
    fun getAddressString(): String {
        return "$address, $city, $district, $state"
    }
}

fun String.decodeLocationString(): Location {
    if (this.isBlank()) return Location()
    return try {
        if ("H4sIAAAAAAAAAAAAAAAAAAAA" == this) {
            return Location()
        }
        ProtoBuf.decodeFromByteArray<Location>(this.decodeBase64Bytes().uncompress(GZIP))
    } catch (e: Exception) {
        Location()
    }
}

fun Location.encodeLocationString(): String {
    return ProtoBuf.encodeToByteArray(this).compress(GZIP).encodeBase64()
}
